<ul class="citations-list">
    @for (citation of citations(); track citation.index) {
        <li class="citation-item">
            <div class="citation-header">
                <span class="citation-index">[{{ citation.index }}]</span>

                <span class="citation-filename" (click)="handleCitationClicked(citation)">
                    {{ citation.title && citation.title.length > 0 ? citation.title : citation.filename }}
                </span>

                <span class="citation-filesize">
                    ({{ citation.fileSize | bytesConverter }})
                </span>

                <span
                    class="citation-chunks-toggle"
                    [class.is-open]="isChunksOpen(citation)"
                    (click)="toggleChunks(citation)"
                >
                    — {{ citation.chunks.length }} {{ citation.chunks.length === 1 ? 'citação' : 'citações' }}
                    <i class="fa-solid" [class.fa-chevron-down]="!isChunksOpen(citation)"
                       [class.fa-chevron-up]="isChunksOpen(citation)"></i>
                </span>
            </div>

            @if (isChunksOpen(citation)) {
                <ul class="chunks-list">
                    @for (chunk of citation.chunks; track chunk.index) {
                        <li
                            [id]="'citation-' + citation.index + '-chunk-' + chunk.index"
                            class="chunk-item"
                            [class.chunk-item--open]="isChunkOpen(citation.index, chunk.index)"
                            [class.chunk-item--highlighted]="isHighlighted(citation.index, chunk.index)"
                            (click)="handleChunkClicked(chunk, citation)"
                        >
                            <span class="chunk-index">[{{ citation.index }}.{{ chunk.index }}]</span>

                            @if (isChunkOpen(citation.index, chunk.index)) {
                                <span class="chunk-content">@if (chunkHasPage(chunk)) {<span class="chunk-page">({{ chunkPageLabel(chunk) }})&nbsp;</span>}{{ chunk.content }}</span>
                                <span class="chunk-toggle-label chunk-toggle-label--close">[fechar]</span>
                            } @else {
                                <span class="chunk-summary">
                                    <span class="chunk-preview">@if (chunkHasPage(chunk)) {<span class="chunk-page">({{ chunkPageLabel(chunk) }})&nbsp;</span>}{{ chunkPreview(chunk.content) }}</span>
                                </span>
                                <span class="chunk-toggle-label chunk-toggle-label--expand">[expandir]</span>
                            }
                        </li>
                    }
                </ul>
            }
        </li>
    }
</ul>
